<template>
<span>
<pazar-asnaf-hero></pazar-asnaf-hero>
<pazar-asnaf-details></pazar-asnaf-details>
    <page-footer></page-footer>
</span>
</template>
<script>
import PageFooter from '@/components/PageFooter';
import PazarAsnafHero from '@/components/PazarAsnafHero';
import PazarAsnafDetails from '@/components/PazarAsnafDetails';
export default {
    name :'pazarsanati',
    components:{
     PazarAsnafHero,
     PazarAsnafDetails,
        PageFooter
    }

    
};
</script>


